import { gsap } from 'gsap'

export default {
  name: 'home-to-archive-transition',
  leave(data) {
    return gsap.to(data.current.container, {
      duration: 0.7,
      x: '-100%',
      autoAlpha: 0,
      ease: 'power2.in',
    })
  },
  enter(data) {
    document.documentElement.scrollTop = 0

    const items = data.next.container.querySelectorAll('.c-archive_list_item')

    return gsap.timeline().fromTo(data.next.container, {
      autoAlpha: 0,
    }, {
      duration: 0.7,
      autoAlpha: 1,
      ease: 'linear',
    }).fromTo(items, {
      autoAlpha: 0,

    }, {
      duration: 0.7,
      autoAlpha: 1,

      stagger: 0.1,
      ease: 'power2.inOut',
    }, '-=0.4')
  },
  from: {
    namespace: [
      'home',
    ],
  },
  to: {
    namespace: [
      'archive',
    ],
  },
}
